<template>
    <div>
        <div class="container-fluid white-bg no-shadow">
            <div class="container align-middle">
                <p>Красивый и мелодичный испанский язык раньше был не слишком популярным, но сейчас его изучают во многих образовательных центрах. Сеть международных языковых школ &laquo;Полиглотики&raquo; предлагает уникальную возможность начать дистанционное обучение испанскому языку для детей. Для этого мы создали уникальную платформу HomeTeacher, с помощью которой каждый желающий сможет пройти изучение иностранного языка в комфортной домашней обстановке.</p>

                <h2 class="greenh2">Особенности платформы</h2>

                <p>Удаленное обучение детей испанскому языку с помощью платформы HomeTeacher практически ничем не отличается от индивидуальных офлайн занятий в детских центрах Полиглотики. Для создания уроков используются те же программы и методики, причем каждая из них соответствует СанПиНам и не имеет аналогов в мире.</p>

                <h2 class="greenh2">Онлайн школа испанского языка для детей подходит для:</h2>

                <ul>
                    <li><span>Малышей до 3 лет, родители которых хотят обеспечить не только языковое, но и всестороннее развитие ребенка;</span></li>
                    <li><span>Дошкольников, которые постепенно готовятся к школе;</span></li>
                    <li><span>Школьников, которые уже начали изучать испанский, но хотят достичь более продвинутого уровня владения языком.</span></li>
                </ul>

                <p>Всего на платформе HomeTeacher представлено 70 программ обучения разных уровней сложности. Долго выбирать курс не придется: родителям достаточно выбрать язык и указать возраст ребенка, а система автоматически подберет несколько подходящих вариантов на выбор.</p>

                <h2 class="greenh2">Как проходит обучение?</h2>

                <p>Онлайн уроки испанского языка практически ничем не отличаются от традиционных офлайн занятий в &laquo;Полиглотиках&raquo;. Разница лишь в том, что обучение проводится не в группах, а индивидуально.</p>

                <h2 class="greenh2">Чтобы начать обучение, достаточно:</h2>

                <ul>
                    <li><span>Выбрать курс и оплатить его стоимость;</span></li>
                    <li><span>Зайти в личный кабинет, чтобы получить доступ к обучающим материалам;</span></li>
                    <li><span>Выбрать подходящее время для занятий и включить урок.</span></li>
                </ul>

                <p>Система HomeTeacher создана таким образом, чтобы обучение мог пройти каждый желающий.
                    Для просмотра видео уроков совсем не обязательно использовать мощный компьютер: ролики будут успешно воспроизводиться на любом электронном устройстве,
                    а тесты-тренажеры открываться как в мобильной, так и компьютерной версии сайта.</p>

                <h2 class="greenh2">Онлайн курсы испанского языка для детей имеют еще несколько важных преимуществ:</h2>

                <ol>
                    <li><span>Видеоурок в любой момент можно поставить на паузу или воспроизвести повторно, если ребенок не понял материал. Все обучающие пособия, видео, тренажеры и флэш-карты на весь период занятий остаются в бесплатном свободном доступе в кабинете, поэтому пройденный материал можно повторить в любое удобное время.</span></li>
                    <li><span>Уроки проводят носители языка, поэтому с первых минут просмотра >ребенок погружается в лингвистическую среду, быстрее преодолевает языковой барьер и формирует активный словарный запас.</span></li>
                    <li><span>В разработке уроков принимают участие не только педагоги и методисты, но также психологи и дизайнеры. Благодаря этому каждое видео полностью соответствует возрастным особенностям ребенка, а яркий видеоряд и постоянная смена видов деятельности помогает сохранять высокую концентрацию внимания.</span></li>
                </ol>

                <p>Все уроки в личном кабинете выложены в четкой, тщательно продуманной логической последовательности, поэтому проблем с прохождением полного курса не возникнет, а после завершения обучения ребенок получит яркий сертификат.</p>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Lang2"
    }
</script>

<style scoped>
    .no-shadow p,li{color: #000; font-size: 18px;}
    .no-shadow ul li{margin-bottom: 20px; padding-left: 10px;}
    .no-shadow ul {list-style-image: url(~@/assets/hometeacher/images/redok.png);}
    .no-shadow{margin-bottom: 70px;}
    .no-shadow li{font-family: "Manrope Bold"; color:#5ab947;}
    .no-shadow li span {font-family: "Manrope Light"; color: #000;}
    .no-shadow ol li{margin-bottom: 20px; padding-left: 5px;}
</style>
